export const HTTP_TIMEOUT = 5;
export const DEFAULT_MAP_RANGE = 20;
export const DEFAULT_MAP_TYPE = "roadmap";
export const DEFAULT_ZOOM = 15;
export const DISABLE_DEFAULT_UI = true;
export const DEFAULT_COORDS = { lat: 48.8589466, lng: 2.276995 };
export const PLACES_RADIUS_MAX = 4000; // in meters, number of meters accepted to look around in a search
export const SEARCH_ZOOM = 14;
export const ACCEPTED_BUSINESSES_TYPES = [
  "bakery",
  "bar",
  "book_store",
  "cafe",
  "train_station",
  "restaurant",
  "library",
];
export const MAPS_API_KEY = "AIzaSyBb78x9yvx8EK5TP7mrhhfDJ1K3ZXR2iX4";

export const DETAILS_IMAGE_MAX_WIDTH = 650;
export const DETAILS_IMAGE_MAX_HEIGHT = 650;

export const MINIMUM_OF_USER_FAKE = 4000;

export const FILE_UPLOAD_MAX = 3000; //  ko
export const AUTHORIZED_FILE_TYPES = ["pdf", "png", "jpg", "jpeg"];

// EMAIL STUFF
export const OWNER_CONTACT_EMAIL = "owner@maika.coffee";

export const TERMS_CONDITIONS_URL =
  "https://maika.coffee/terms-conditions.html";
export const PRIVACY_POLICY_URL = "https://maika.coffee/privacy-policy.html";

// APP URL
export const IOS_URL =
  "https://apps.apple.com/us/app/maïka-cafés-to-work-from/id1588756102";
export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.gsy.maika.coffee";
export const QR_CODE_URL = "https://maika.coffee/images/downloadqrcode.png";

// HTTP REQUESTS
export const HTTP_BASE_URL_DEV = "http://localhost:3000/";
export const HTTP_BASE_URL_PROD = "https://maika.coffee/";
// export const HTTP_BASE_URL_DEV = "https://maikacc.cluster024.hosting.ovh.net/";
